"use strict";
import { isBetaEnv, isProdEnv } from "utilities/src/environment";
function isAppUniswapOrg() {
  return true;
}
function isAppUniswapStagingOrg() {
  return true;
}
export function isBrowserRouterEnabled() {
  if (isProdEnv()) {
    if (isAppUniswapOrg() || isAppUniswapStagingOrg() || isLocalhost(window.location)) {
      return true;
    }
    return false;
  }
  return true;
}
function isLocalhost({ hostname }) {
  return hostname === "localhost";
}
export function isRemoteReportingEnabled() {
  if (isBetaEnv() && !isAppUniswapStagingOrg()) {
    return false;
  }
  if (isProdEnv() && !isAppUniswapOrg()) {
    return false;
  }
  return process.env.REACT_APP_SENTRY_ENABLED === "true";
}
